import { render, staticRenderFns } from "./AffinityPeople.vue?vue&type=template&id=3b54d4b5"
import script from "./AffinityPeople.vue?vue&type=script&lang=js"
export * from "./AffinityPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports